import EntitlementControls from './EntitlementControls';

export default EntitlementControls;
